module.exports = __webpack_public_path__ + "img/spotify.bf024760.svg";